import RoutedTabs from '@/components/RoutedTabs';
import React from 'react';

export const QipMetricBuilder = () => {
  const tabs = [
    { name: 'Questions', path: 'questions' },
    {
      name: 'Question Groups',
      path: 'question-groups',
    },
  ];

  return (
    <div className="block">
      <div className="border-b border-gray-200">
        <RoutedTabs pathPrefix="/behavior-config/qip-metric-builder/" tabs={tabs} />
      </div>
    </div>
  );
};
